module.exports = __webpack_public_path__ + "static/media/Baslik.aff14881.png";